"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.utils = void 0;
const react_1 = __importDefault(require("react"));
const utils = (currentStep, steps, style) => {
    return react_1.default.createElement(react_1.default.Fragment, null,
        steps.map((step, i) => {
            const currentCSS = {
                backgroundColor: i === currentStep ? style.bgColorActive : (i < currentStep ? style.bgColor : ''),
                fontFamily: i === currentStep ? "DIN Bold" : '',
                color: i <= currentStep ? style.color : ''
            };
            return (react_1.default.createElement("div", { key: i, className: "plans-step-card-payment", style: currentCSS },
                react_1.default.createElement("img", { src: step.icon, alt: "", className: "plans-steps-icon d-none d-lg-block" }),
                react_1.default.createElement("span", null, step.title)));
        }),
        //Second row with spaces 
        steps.map((step, i) => {
            return react_1.default.createElement("div", { key: i, className: "space-bottom", style: { backgroundColor: i === currentStep ? "#eeeeef" : '' } });
        }));
};
exports.utils = utils;
//# sourceMappingURL=utils.js.map